import { EARTH_RADIUS_METERS, METERS_PER_MILE, METERS_PER_YARD, METERS_PER_KM } from "../constants/geometry";
export var degreesToRadians = function (deg) {
    return deg * (Math.PI / 180);
};
export var radiansToDegrees = function (rad) {
    return rad * (180 / Math.PI);
};
export var metersToMiles = function (meters) {
    return meters / METERS_PER_MILE;
};
export var metersToYards = function (meters) {
    return meters / METERS_PER_YARD;
};
export var metersToKm = function (meters) {
    return meters / METERS_PER_KM;
};
export var calculateDistanceBetweenLatLngs = function (latLng1, latLng2) {
    // Based on haversine formula:
    // https://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
    var latDiff = degreesToRadians(latLng2.lat - latLng1.lat);
    var lngDiff = degreesToRadians(latLng2.lng - latLng1.lng);
    var squareOfHalfChordLength = Math.sin(latDiff / 2) * Math.sin(latDiff / 2) + Math.cos(degreesToRadians(latLng1.lat))
        * Math.cos(degreesToRadians(latLng2.lat)) * Math.sin(lngDiff / 2) * Math.sin(lngDiff / 2);
    var angularDistance = 2 * Math.atan2(Math.sqrt(squareOfHalfChordLength), Math.sqrt(1 - squareOfHalfChordLength));
    var distance = EARTH_RADIUS_METERS * angularDistance;
    return parseFloat(distance.toFixed(2));
};
